// These need to match Kratos headers for "preInitiate"
export const MAFIA_CLIENT_MOBILE_PREFIX = 'KRATOS-MOBILE-';
export const MAFIA_CLIENT_DESKTOP_PREFIX = 'KRATOS-DESKTOP-';
export const MAFIA_CLIENT_ZPOT_PREFIX = 'KRATOS-ZPOT-';
